<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import CreateOrEditList from '~/components/modal-windows/CreateOrEditList.vue'
import ShareLink from '~/components/modal-windows/ShareLink.vue'
import { useSharing } from '~/composables/sharing'
import constants from '~/constants'
import helpers from '~/helpers'
import { useAuthStore } from '~/store/auth'
import { useCartStore } from '~/store/cart'
import type { CartProductData } from '~/types/cart'

const authStore = useAuthStore()
const cartStore = useCartStore()

const { copyLink } = useSharing()

async function copyListUrl (listId: string): Promise<void> {
  const listUrl = `${constants.siteUrl}${helpers.getListPath({ id: listId })}`

  if (authStore.isUser) {
    await openCopyLinkModalWindow(listUrl)
  } else {
    copyLink(listUrl)
  }
}

async function openCopyLinkModalWindow (link: string): Promise<void> {
  await useModal({ component: ShareLink, attrs: { link } }).open()
}

async function openCreateOrEditListModalWindow (): Promise<void> {
  await useModal({
    component: CreateOrEditList,
    attrs: {
      productIds: cartStore.cartProductsData.map((x: CartProductData): string => x.id),
      onLoadData: copyListUrl
    }
  }).open()
}
</script>

<template>
  <a
    class="
      flex h-min items-center rounded-[8px] bg-white p-2.5 text-[rgba(67,66,66,.4)] !no-underline transition-all
      hover:text-main-green sm:px-2.5 sm:py-1.5
    "
    href="#"
    @click.prevent="openCreateOrEditListModalWindow"
  >
    <SvgIcon class="!size-4" name="outlined/share" />

    <span class="ml-1 hidden text-[13px] sm:block">Поделиться списком</span>
  </a>
</template>
